if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.enhanceQuickViewModalDesign();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      enhanceQuickViewModalDesign() {
        const container = this.modalContent;
        if (!container) return;

        // 1. Force Outfit font on Product Title
        container.querySelectorAll('.product__title, .product__title h1, .product__title h2, .product__title *, h1, h2').forEach(el => {
          el.style.setProperty('font-family', "'Outfit', sans-serif", 'important');
          el.style.setProperty('font-weight', '700', 'important');
          el.style.setProperty('color', '#111111', 'important');
          el.style.setProperty('font-size', '2.2rem', 'important');
        });

        // 2. Force Brand Green on Sale Price
        container.querySelectorAll('.price .price-item--sale, .price-item--sale, .price-item').forEach(el => {
          el.style.setProperty('color', '#497825', 'important');
          el.style.setProperty('font-weight', '700', 'important');
          el.style.setProperty('font-family', "'Outfit', sans-serif", 'important');
          el.style.setProperty('font-size', '2.2rem', 'important');
        });

        // 3. Convert Select Dropdowns into Size Pill Chips
        const selects = container.querySelectorAll('select.select__select');
        selects.forEach(select => {
          const selectContainer = select.closest('.select') || select.parentElement;
          if (!selectContainer || selectContainer.nextElementSibling?.classList.contains('quick-view-chip-group')) return;

          const chipGroup = document.createElement('div');
          chipGroup.className = 'quick-view-chip-group';
          chipGroup.style.cssText = 'display: flex !important; flex-wrap: wrap !important; gap: 10px !important; margin: 12px 0 16px 0 !important;';

          Array.from(select.options).forEach((opt, idx) => {
            const chip = document.createElement('div');
            chip.className = 'quick-view-chip' + (select.selectedIndex === idx ? ' is-active' : '');
            chip.textContent = opt.text;
            chip.style.cssText = select.selectedIndex === idx
              ? 'border-radius: 30px !important; border: 1.5px solid #497825 !important; background: #497825 !important; color: #ffffff !important; padding: 8px 20px !important; font-family: "Outfit", sans-serif !important; font-weight: 600 !important; font-size: 1.15rem !important; cursor: pointer !important; box-shadow: 0 4px 12px rgba(73, 120, 37, 0.25) !important;'
              : 'border-radius: 30px !important; border: 1.5px solid rgba(73, 120, 37, 0.3) !important; background: #f8faf6 !important; color: #111111 !important; padding: 8px 20px !important; font-family: "Outfit", sans-serif !important; font-weight: 600 !important; font-size: 1.15rem !important; cursor: pointer !important;';

            chip.addEventListener('click', () => {
              select.selectedIndex = idx;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              chipGroup.querySelectorAll('.quick-view-chip').forEach((c, cIdx) => {
                c.className = 'quick-view-chip' + (cIdx === idx ? ' is-active' : '');
                c.style.cssText = cIdx === idx
                  ? 'border-radius: 30px !important; border: 1.5px solid #497825 !important; background: #497825 !important; color: #ffffff !important; padding: 8px 20px !important; font-family: "Outfit", sans-serif !important; font-weight: 600 !important; font-size: 1.15rem !important; cursor: pointer !important; box-shadow: 0 4px 12px rgba(73, 120, 37, 0.25) !important;'
                  : 'border-radius: 30px !important; border: 1.5px solid rgba(73, 120, 37, 0.3) !important; background: #f8faf6 !important; color: #111111 !important; padding: 8px 20px !important; font-family: "Outfit", sans-serif !important; font-weight: 600 !important; font-size: 1.15rem !important; cursor: pointer !important;';
              });
              this.updateModalEstimatedCost();
            });
            chipGroup.appendChild(chip);
          });

          selectContainer.style.display = 'none';
          selectContainer.parentNode.insertBefore(chipGroup, selectContainer.nextSibling);
        });

        // 4. Add Live Estimated Total Box
        if (!container.querySelector('.quick-view-estimated-cost')) {
          const formButtons = container.querySelector('.product-form__buttons') || container.querySelector('product-form');
          if (formButtons) {
            const estBox = document.createElement('div');
            estBox.className = 'quick-view-estimated-cost';
            estBox.style.cssText = 'margin: 14px 0 14px 0 !important; padding: 12px 18px !important; background: #f8faf6 !important; border-radius: 18px !important; border: 1.5px solid rgba(73, 120, 37, 0.2) !important; display: flex !important; align-items: center !important; justify-content: space-between !important; font-family: "Outfit", sans-serif !important;';
            estBox.innerHTML = '<span class="estimated-label" style="font-size: 1.15rem; font-weight: 600; color: #444444;">Estimated Total:</span><span class="estimated-amount" style="font-size: 1.45rem; font-weight: 700; color: #497825;">--</span>';
            formButtons.parentNode.insertBefore(estBox, formButtons);
          }
        }

        // 5. Quantity Selector Rounded Pill Styling
        container.querySelectorAll('.quantity, quantity-input').forEach(q => {
          q.style.setProperty('border-radius', '30px', 'important');
          q.style.setProperty('border', '1.5px solid rgba(73, 120, 37, 0.3)', 'important');
          q.style.setProperty('background', '#f8faf6', 'important');
          q.style.setProperty('height', '46px', 'important');
          q.style.setProperty('overflow', 'hidden', 'important');
        });

        container.querySelectorAll('.quantity__button').forEach(btn => {
          btn.style.setProperty('color', '#497825', 'important');
          btn.style.setProperty('font-family', "'Outfit', sans-serif", 'important');
          btn.style.setProperty('font-weight', '700', 'important');
          btn.style.setProperty('font-size', '1.4rem', 'important');
          btn.addEventListener('click', () => setTimeout(() => this.updateModalEstimatedCost(), 50));
        });

        container.querySelectorAll('.quantity__input').forEach(inp => {
          inp.style.setProperty('font-family', "'Outfit', sans-serif", 'important');
          inp.style.setProperty('font-weight', '700', 'important');
          inp.style.setProperty('font-size', '1.2rem', 'important');
          inp.style.setProperty('color', '#111111', 'important');
          inp.addEventListener('input', () => setTimeout(() => this.updateModalEstimatedCost(), 50));
        });

        // 6. Round Corner CTA Buttons
        container.querySelectorAll('.product-form__submit, button[name="add"], .shopify-payment-button__button').forEach(btn => {
          btn.style.setProperty('border-radius', '30px', 'important');
          btn.style.setProperty('background', '#497825', 'important');
          btn.style.setProperty('color', '#ffffff', 'important');
          btn.style.setProperty('font-family', "'Outfit', sans-serif", 'important');
          btn.style.setProperty('font-size', '1.3rem', 'important');
          btn.style.setProperty('font-weight', '600', 'important');
          btn.style.setProperty('height', '48px', 'important');
          btn.style.setProperty('min-height', '48px', 'important');
        });

        this.updateModalEstimatedCost();
      }

      updateModalEstimatedCost() {
        const container = this.modalContent;
        if (!container) return;

        const estAmount = container.querySelector('.estimated-amount');
        if (!estAmount) return;

        const priceElem = container.querySelector('.price-item--sale, .price-item--regular, .price-item');
        const qtyInput = container.querySelector('.quantity__input');

        if (!priceElem || !qtyInput) return;

        const priceText = priceElem.textContent.trim();
        const numericMatch = priceText.match(/[\d,]+\.?\d*/);

        if (!numericMatch) return;

        const unitPrice = parseFloat(numericMatch[0].replace(/,/g, ''));
        const qty = parseInt(qtyInput.value) || 1;
        const total = unitPrice * qty;

        estAmount.textContent = `Rs.${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PKR`;
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
